/** One entrance beat for the empty thread: suggestion chips and prompt cards. */
export const WORKSPACE_AGENT_ZERO_STATE_ENTRANCE_DURATION_S = 0.22;
export const WORKSPACE_AGENT_ZERO_STATE_ENTRANCE_STAGGER_S = 0.065;
export const WORKSPACE_AGENT_ZERO_STATE_ENTRANCE_TRANSLATE_Y_PX = 6;
